import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import IndexPage from '../views/IndexPage.vue'
import ProductPage from '@/views/ProductPage.vue'
import CustomCakeCategory from '../views/CustomCakeCategoryPage.vue'
import CustomCake from '../views/CustomCakePage.vue'
import CartPage from '@/views/CartPage.vue'
import AboutUs from '../views/AboutPage.vue'
import ContactUs from '../views/ContactPage.vue'
import ProductViewPage from '@/views/ProductViewPage.vue'
import LoginPage from '../views/auth/LoginPage.vue'
import RegisterPage from '../views/auth/RegisterPage.vue'
import ForgotPasswordPage from '../views/auth/ForgotPasswordPage.vue'
import ResetPasswordPage from '../views/auth/ResetPasswordPage.vue'
import UserDashboardPage from '../views/user/UserDashboardPage.vue'
import CheckoutPage from '@/views/CheckoutPage.vue'
import AfterPaymentPage from '@/views/AfterPaymentPage.vue'
import CareersPage from '@/views/CareersPage.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexPage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPage
  },
  {
    path: '/home',
    name: 'home',
    meta: { requiresAuth: true },
    component: UserDashboardPage
  },
  {
    path: '/forgot-password',
    name: 'forgot_password',
    component: ForgotPasswordPage
  },
  {
    path: '/reset-password',
    name: 'reset_password',
    component: ResetPasswordPage
  },
  {
    path: '/our-menu',
    name: 'our-menu',
    component: ProductPage
  },
  {
    path: '/custom-cake-category',
    name: 'custom-cake-category',
    component: CustomCakeCategory
  },
  {
    path: '/custom-cake/:category_slug',
    name: 'custom-cake',
    component: CustomCake
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: AboutUs
  },
  {
    path: '/careers',
    name: 'careers',
    component: CareersPage
  },
  {
    path: '/cart',
    name: 'cart',
    component: CartPage
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutPage
  },
  {
    path: '/payment-success/:id',
    name: 'payment-success',
    component: AfterPaymentPage
  },
  {
    path: '/payment-failed',
    name: 'payment-failed',
    component: AfterPaymentPage
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUs
  },
  {
    path: '/:category_slug/:product_slug?',
    name: 'show-product',
    component: ProductViewPage
  },
  // {
  //   path: '/contact-us',
  //   name: 'contact-us',
  //   component: ContactUs
  // },
  // {
  //   path: '/product',
  //   name: 'product',
  //   component: Product
  // },
  // {
  //   path: '/product-detail/:slug',
  //   name: 'product-detail',
  //   component: ProductDetail
  // },
  // Add other routes as needed  
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFoundPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const { isAuthenticated } = useAuth()

  if (to.meta.requiresAuth && !isAuthenticated()) {
    next({ name: 'login'})
  } else if (to.name === 'login' && isAuthenticated()) {
    next({ name: 'home' })
  } else {
    next()
  }
})

export default router